var map = {
	"./Abhinav/images/LoginBackgroundImage.svg": [
		9067,
		9067
	],
	"./Agrasen/images/LoginBackgroundImage.svg": [
		35391,
		5391
	],
	"./Bhagini/images/LoginBackgroundImage.svg": [
		44444,
		4444
	],
	"./Deogiri/images/LoginBackgroundImage.svg": [
		7539,
		7539
	],
	"./JCOM/images/LoginBackgroundImage.svg": [
		49409,
		9409
	],
	"./MOGAVEERA/images/LoginBackgroundImage.svg": [
		60179,
		179
	],
	"./Mahesh/images/LoginBackgroundImage.svg": [
		72838,
		2838
	],
	"./NCBM/images/LoginBackgroundImage.svg": [
		17990,
		7990
	],
	"./Noble/images/LoginBackgroundImage.svg": [
		88420,
		8420
	],
	"./RSSB/images/LoginBackgroundImage.svg": [
		77994,
		7994
	],
	"./Samta/images/LoginBackgroundImage.svg": [
		75208,
		5208
	],
	"./Satara/images/LoginBackgroundImage.svg": [
		48202,
		8202
	],
	"./Sawji/images/LoginBackgroundImage.svg": [
		57620,
		7620
	],
	"./Shriraksh/images/LoginBackgroundImage.svg": [
		42853,
		2853
	],
	"./Suvarna/images/LoginBackgroundImage.svg": [
		61396,
		1396
	],
	"./Ucob/images/LoginBackgroundImage.svg": [
		63307,
		3307
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 17444;
module.exports = webpackAsyncContext;